import { SVG } from '@svgdotjs/svg.js'
import { Canvg } from 'canvg'

export const getSVG = ({
  width,
  height,
  title,
  captionsSVG,
  chartSVG,
  titleStyles = {
    fontSize: '2.8em',
    fontFamily: 'Barlow-Medium, sans-serif',
    fontWeight: 600,
    fill: '#004BC7',
    x: '5%',
    y: '10%',
  },
  imagePosition = {
    x: '5%',
    y: '25%',
  },
  footnotes,
}) => {
  const captionsStr = captionsSVG
    ? `<svg x='60%' y='25%'>
        <rect x='0' y='0' width='100%' h='100%'></rect>
        ${captionsSVG.title}
        ${captionsSVG.text}
      </svg>`
    : ''

  const footnotesStyle = {
    fontFamily: 'Barlow-Light',
    fontSize: '1.4em',
    fill: '#BFBFBF',
  }

  let footer = ''
  if (footnotes) {
    const textBoxWidth = (width * 35) / 100
    const footerLeftText = _createSVGTextBox(
      footnotes.title,
      0,
      textBoxWidth,
      footnotesStyle,
    )
    const footerRightText = _createSVGTextBox(
      footnotes.filters,
      0,
      textBoxWidth,
      footnotesStyle,
    )

    footer = footnotes
      ? `<svg x='${titleStyles.x}' y='${
          height - 100
        }' width='100%' height='100'>
                    <rect fill='white' width='100%' height='100%'></rect>
                    ${footerLeftText.svg}
                    <svg x='55%'>
                    <rect fill='white' width='100%' height='100%'></rect>
                      ${footerRightText.svg}
                    </svg>
                  </svg>`
      : ''
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" 
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox='0 0 ${width} ${height}' 
            width='${width}' height='${height}'>
              <rect width='100%' height='100%' fill='white'></rect>
              <g x='${titleStyles.x}' y='${titleStyles.y}'>
                <text 
                  font-size='${titleStyles.fontSize}'
                  font-family='${titleStyles.fontFamily}'
                  font-weight='${titleStyles.fontWeight}'
                  fill='${titleStyles.fill}'
                  >
                  ${title}
                </text>
              </g>
              <svg x='${imagePosition.x}' y='${imagePosition.y}'>
                ${chartSVG}
              </svg>
              ${captionsStr}
              ${footer}
        </svg>`
}

export const createImageSimple = (chartProps, chartElement) => {
  // const chartElement = highchartElement.chartElement || highchartElement
  const svgNode = chartElement.chart.getSVG()
  const container = document.createElement('container')
  container.innerHTML = svgNode
  container.children[0].setAttribute('transform', 'scale(1.5)')
  const dimensions = {
    width: chartElement.chart.chartWidth * 1.7,
    height: chartElement.chart.chartHeight * 2,
    x: chartElement.chart.chartWidth * 0.08,
    y: chartElement.chart.chartHeight * 0.25 + 50,
  }

  const titleStyles = {
    fill: 'black',
    y: '10%',
    fontSize: '2rem',
    fontFamily: 'Barlow-Medium, sans-serif',
    x: dimensions.x,
  }

  const svg = getSVG({
    width: dimensions.width,
    height: dimensions.height,
    title: chartProps.title,
    chartSVG: container.children[0].outerHTML,
    titleStyles,
    imagePosition: {
      x: `${dimensions.x}`,
      y: `${dimensions.y}`,
    },
  })

  return convertSVG2PNG(svg)
}

const _createSVGTextBox = (text, y, boxWidth, textStyle) => {
  const draw = SVG()
  const LINE_HEIGHT = 8
  const words = text.split(' ')
  let line = []
  let svgSpan = '<tspan x="0" dy="0">'
  let textHeight
  words.forEach(word => {
    line.push(word)
    const textbox = draw
      .text(line.join(', '))
      .attr('font-size', textStyle.fontSize)
      .attr('font-family', textStyle.fontFamily)
    const { w, h } = textbox.bbox()
    if (!textHeight) textHeight = h
    if (w < boxWidth) {
      svgSpan += word + ' '
    } else {
      svgSpan += `</tspan><tspan x="0" dy="${h + LINE_HEIGHT}">`
      line = []
    }
  })

  svgSpan += '</tspan>'
  const result = `<text y='${y + textHeight}' font-size='${
    textStyle.fontSize
  }' font-family='${textStyle.fontFamily}' fill='${
    textStyle.fill
  }'>${svgSpan}</text>`
  const { y2 } = draw.svg(result).bbox()

  return {
    svg: result,
    lastTextAnchor: y2,
  }
}

export const convertSVG2PNG = (svg, format = 'png') => {
  const canvas = document.querySelector('canvas')
  const ctx = canvas.getContext('2d')
  const v = Canvg.fromString(ctx, svg)
  v.start()
  window.addEventListener('beforeunload', () => v.stop())
  return canvas.toDataURL(`image/${format}`, '100')
}

export const copyrightTitle = `© ${new Date().getFullYear()} CEM Benchmarking Inc.`

export async function download(url, name = 'download', type = 'png') {
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = await toDataURL(url)
  a.download = name + '.' + type
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

function toDataURL(url) {
  return fetch(url)
    .then(response => {
      return response.blob()
    })
    .then(blob => {
      return URL.createObjectURL(blob)
    })
}
